import { render, staticRenderFns } from "./TechnologicalInnovationDetail.vue?vue&type=template&id=ad36ae7c&scoped=true"
import script from "./TechnologicalInnovationDetail.vue?vue&type=script&lang=js"
export * from "./TechnologicalInnovationDetail.vue?vue&type=script&lang=js"
import style0 from "./TechnologicalInnovationDetail.vue?vue&type=style&index=0&id=ad36ae7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad36ae7c",
  null
  
)

export default component.exports